<template>
  <div class="stripe-modal">
    <p class="stripe-modal__title">
      {{ $t('stripe.modal_title') }}
    </p>
    <div id="payment-element"></div>
    <UiButton
      :disabled="disablePaymentButton"
      class="stripe-modal__button"
      @click="confirmPayment"
    >
      {{ $t(buttonText) }}
    </UiButton>
  </div>
</template>

<script setup>
defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  paymentElement: {
    type: Object,
    default: () => ({}),
  },
  disablePaymentButton: {
    type: Boolean,
    default: true,
  },
  confirmPayment: {
    type: Function,
    required: true,
  },
  buttonText: {
    type: String,
    default: 'button.pay',
  },
});

watch(
  () => props.paymentElement,
  () => {
    if (props.paymentElement) {
      props.paymentElement.mount('#payment-element');
    }
  },
);

onMounted(() => {
  if (props.paymentElement) {
    props.paymentElement.mount('#payment-element');
  }
});
</script>

<style lang="scss">
@use '@styles/setup/variables.scss' as *;
@use '@styles/setup/mixins.scss' as *;

.stripe-modal {
  padding: 20px;
  padding-top: 47px;

  &__title {
    font-size: 20px;
    line-height: 110%;
    letter-spacing: 0.035em;
    margin-bottom: 20px;

    @include tablet {
      font-size: 24px;
    }
  }

  &__button {
    width: 100%;
    margin-top: 20px;
  }
}
#address-element .__PrivateStripeElement {
  background: green !important;

  #Field-nameInput {
    display: none;
    background: red;
  }
}
</style>
